module.exports = __webpack_public_path__ + "static/assets/d4d861d27154cc8528d61e531891e4c6.svg";